<template>
  <div class="good1-view">
    <div class="good-view-img" :id="dateId">
      <div>
        <img :src="item.image_text" @click="moreTap()" v-if="clientWidth != 0" :style="{ width: clientWidth + 'px' }" />
        <!-- <img :src="item.image_text" @click="moreTap()" v-if="!close" style="width: 100%;height: 100%;" /> -->
      </div>
    </div>
    <div class="good-view-text"><span style="margin: 0 1rem;">{{ item.title }}</span></div>
    <sphereViewer v-model="value" :goodsobject="goodsobject" @scroll="scroll()"></sphereViewer>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
    },
    goodsobject: {
      type: Object,
    },
    close: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      value: 'false',
      clientWidth: 0,
      dateId: new Date().valueOf(),
    };
  },
  mounted() {
	    setTimeout(() => {
      const { clientWidth } = document.getElementById(this.dateId);
      if (this.item.width * 0.8504398826979472 > this.item.height) {
			  this.clientWidth = clientWidth;
      } else {
			  this.clientWidth = isNaN(clientWidth * (this.item.width / this.item.height) * 0.8504398826979472) ? 0 : clientWidth * (this.item.width / this.item.height) * 0.8504398826979472;
      }
	    }, 500);
    // const img = new Image();
    // img.src = this.item.image_text;
    // img.onload = () => {
    //   setTimeout(() => {
    //     if (img.width * 0.8504398826979472 > img.height) {
    //       this.clientWidth = clientWidth;
    //     } else {
    //       this.clientWidth = clientWidth * (img.width / img.height) * 0.8504398826979472;
    //     }
    //   }, 800);
    // };
  },
  methods: {
    moreTap() {
      this.value = 'true';
    },
    scroll() {
      this.$emit('scroll');
    },
  },
};
</script>

<style lang="less">
.good1-view {
  width: 48%;
  display: flex;
  flex-direction: column;
  padding: 4% 0;
  font-size: 1.2rem;
  background-color: #fff;
  margin-bottom: 4%;
  border-radius: 0.5rem;

  .good-view-img {
    width: 100%;
    padding-top: 85.04398826979472%;
    position: relative;
  }
  .good-view-img > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .good-view-text {
    margin-top: 1rem;
    border-top: 1px solid #F4F4F4;
    padding-top: 1rem;
    span{
      display: -webkit-box;
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
